import debounce from 'lodash/debounce';
import { useState, useEffect, useCallback } from 'react';

const useToTopButtonState = (): boolean => {
  const [isToTopButtonVisible, setIsToTopButtonVisible] = useState(false);

  const handleScroll = useCallback(
    debounce(() => {
      const viewportHeight = window.innerHeight;
      const { body, documentElement: html } = document;
      const screenHeight = Math.max(
        body.getBoundingClientRect().height,
        html.getBoundingClientRect().height
      );
      const scrollPosition = window.scrollY;
      setIsToTopButtonVisible(
        screenHeight > 2 * viewportHeight && scrollPosition > viewportHeight
      );
    }, 500),
    []
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isToTopButtonVisible;
};

export default useToTopButtonState;
